<template>
  <div class="applyLogin">
    <div class="login-kv"></div>
    <div class="login">
      <input class="login-input" name="name" placeholder="请输入患者姓名" placeholder-class="login-txtStyle" v-model.trim="name" />
      <input class="login-input" type="tel" pattern="[0-9]*" maxlength="11" name="mobile" placeholder="请输入手机号" placeholder-class="login-txtStyle" v-model.trim="mobile" />
      <div class="login-item">
        <input class="login-input2" type="digit" pattern="[0-9]*" maxlength="6" name="code" placeholder="请输入验证码" placeholder-class="login-txtStyle" v-model.trim="code" />
        <div class="send_code" @click="getSms">
          <p class="code_txt">{{ btnText }}</p>
        </div>
      </div>
    </div>
    <div class="login-btn">
      <!-- <van-button :disabled="submitBtnDisabled" @click="formLogin" class="up">注册/登录</van-button> -->
      <van-button @click="next()" type="info" round block color="#0AA8AF">注册/登录</van-button>
    </div>
    <PolicyPopup v-if="isPrivacyOpen" ref="policyPopupRef" v-model="checkedPrivacy" :policy-content="privacyConfig.privacy_policy" @has-read="handleHasRead" @confirm-policy="handleConfirmPolicy" />
  </div>
</template>

<script>
import { Login, SendVerifyCode, getPrivacyConfig, privacyRead } from '../../api/api'
import { checkCellphone } from '../../utils/utils'
import Vue from 'vue'
import { Toast } from 'vant'

Vue.use(Toast)
// let hostname = location.hostname;
// hostname = hostname.substring(hostname.indexOf('.'));
// const baseUrlImg = `${location.protocol}//api${hostname}`;
export default {
  name: 'ApplyLogin',
  data() {
    return {
      // baseFileUrl: baseUrlImg,
      name: '',
      mobile: '',
      code: '',
      // kv_image: "",
      // tempKv: "",
      btnText: '获取验证码',
      btnDisabled: false,
      submitBtnDisabled: false,
      seconds: 60,
      checked: false,
      contractText: '', // 知情同意书内容
      showContract: false, // 显示知情同意书
      checkedPrivacy: false, // 隐私政策勾选
      privacyConfig: {}, // 隐私政策配置
      hasReadPolicy: false // 是否阅读隐私政策
    }
  },
  computed: {
    isPrivacyOpen() {
      return this.privacyConfig.is_privacy_open === '1'
    }
  },
  created() {
    getPrivacyConfig()
      .then(res => {
        console.log(res, 'res')
        this.privacyConfig = res.data
      })
      .catch(err => {
        Toast(err.response.data.message)
      })
  },
  methods: {
    getSms() {
      let self = this
      if (self.btnDisabled) {
        return false
      }
      if (!self.mobile) {
        Toast('请输入手机号')
        return false
      } else {
        if (!checkCellphone(self.mobile)) {
          Toast('手机号格式有误')
          return false
        }
      }

      const reqData = {
        mobile: self.mobile
      }
      SendVerifyCode(reqData)
        .then(res => {
          if (res.data.isValid) {
            Toast(res.data.resultContent)
            self.startTimer()
          } else {
            Toast(res.data.resultContent)
          }
        })
        .catch(err => {
          Toast('手机号格式有误')
        })
    },
    startTimer() {
      this.btnDisabled = true
      let seconds = 60
      this.timer = setInterval(() => {
        seconds--
        this.btnText = seconds + '秒'
        if (seconds <= 0) {
          clearInterval(this.timer)
          this.btnText = '重发验证码'
          this.btnDisabled = false
        }
      }, 1000)
    },
    handleHasRead() {
    //   this.checkedPrivacy = true
      this.hasReadPolicy = true
    },
    handleConfirmPolicy() {
      this.next()
      this.$refs.policyPopupRef.closePolicyPopup()
    },
    next() {
      var reg = /^\d{6}$/
      if (!this.name) {
        Toast('请输入患者姓名')
        return false
      } else if (!this.mobile) {
        Toast('请输入手机号')
        return false
      } else if (!checkCellphone(this.mobile)) {
        Toast('手机号格式有误')
        return false
      } else if (!this.code || !reg.test(this.code)) {
        Toast('验证码错误')
        return false
      }
      if (this.isPrivacyOpen) {
        if (!this.hasReadPolicy) {
          this.$refs.policyPopupRef.openPolicyPopup()
          return
        }
        if (!this.checkedPrivacy) {
          this.$toast('请勾选“我已阅读并同意《隐私政策》”')
          return
        }
      }
      this.showContract = true
      // },
      // formLogin() {
      const self = this
      Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true
      })
      self.submitBtnDisabled = true
      Login({
        name: self.name,
        mobile: self.mobile,
        verifycode: self.code
      })
        .then(async res => {
          Toast.clear()
          Toast('登录成功')
          if (this.isPrivacyOpen) {
            await privacyRead({
              patient_id: res.data.id
            })
          }
          let userInfo = this.$store.getters.getUserInfo
          userInfo.patient = res.data
          this.$store.commit('setUserInfo', userInfo)
          this.$router.replace({
            name: 'Blank'
          })
          self.submitBtnDisabled = false
        })
        .catch(err => {
          self.submitBtnDisabled = false
          Toast.clear()
          Toast(err.response.data.message)
        })
    }
  }
}
</script>
<style lang="less">
.applyLogin {
  height: 100%;
  width: 100%;
  .login-kv {
    height: 200px;
    width: 100%;
    margin-bottom: 15px;
    background: url(../../assets/login_banner.png);
    background-size: cover;
    background-position: center;
    img {
      height: 100%;
      width: 100%;
    }
  }

  .login {
    line-height: 20px;
    border-radius: 10px;
    text-align: center;
    box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.1);
    border: 1px solid rgba(255, 255, 255, 0);
    padding: 18px 0;
    margin: 0 30px 50px 30px;
    background: white;
    margin-top: -30px;
    .login-input {
      width: 90%;
      height: 46px;
      // border-radius: 5px;
      color: rgba(136, 136, 136, 1);
      font-size: 15px;
      text-align: left;
      border: transparent;
      border-bottom: 1px solid rgba(232, 232, 232, 1);
      margin: 0 auto;
      padding-left: 10px;
      box-sizing: border-box;
      margin-bottom: 14px;
      background: white;
    }
  }

  .login-item {
    margin: 0 15px;
    display: flex;
    align-items: center;

    .login-input2 {
      padding-left: 10px;
      box-sizing: border-box;
      // width: 65%;
      height: 46px;
      border-radius: 5px;
      color: rgba(136, 136, 136, 1);
      font-size: 15px;
      text-align: left;
      border: transparent;
      // border-bottom: 1px solid rgba(232, 232, 232, 1);
      flex: 1;
      min-width: 0;
    }

    .send_code {
      height: 30px;
      min-width: 100px;
      border-radius: 5px;
      background-color: #33c78e;
      box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.01);
      border: 1px solid rgba(255, 255, 255, 0);
      margin: 0;
      margin-left: 10px;
      padding: 0 10px;

      .code_txt {
        color: rgba(246, 248, 255, 1);
        line-height: 30px;
        font-size: 14px;
        text-align: center;
      }
    }
  }
  .login-btn {
    margin: 15px;
  }

  button.van-button.van-button--info.van-button--normal.van-button--block.van-button--round {
    box-shadow: 0px 2px 7px 0px rgba(11, 105, 177, 0.29);
  }
}

input::-webkit-input-placeholder {
  color: #aab2bd;
  font-size: 15px;
}
input {
  color: #2b2b2b !important;
}
</style>
